module.exports = __webpack_public_path__ + "img/hamburger.dce69d06.svg";